import { useState } from 'react'

import { FillFieldKey } from '@/models/fillApplication'
import { ChangeDotButton } from './ChangeDotButton'
import { ChangeDotDialog } from './ChangeDotDialog'

interface DotNumberRowProps {
  orgId: string
  dotNumber: string
  locked: boolean
  sent: boolean
}

/** The DOT above the form, set on the FMCSA step: changed only through FMCSA again. */
export function DotNumberRow({ orgId, dotNumber, locked, sent }: DotNumberRowProps) {
  const [open, setOpen] = useState(false)

  return (
    <span className="flex items-center gap-2" data-fill-field={FillFieldKey.DOT_NUMBER}>
      <span>DOT {dotNumber}</span>
      <ChangeDotButton locked={locked} sent={sent} onClick={() => setOpen(true)} />
      <ChangeDotDialog orgId={orgId} open={open} onOpenChange={setOpen} currentDot={dotNumber} />
    </span>
  )
}
